module.exports = "<div class=\"background\">\n  <div class=\"container\">\n    <div class=\"section center\">\n      <h1 class=\"center main-title\">\n        Bienvenue dans\n      </h1>\n      <img id=\"img-sygem\"\n        src=\"{{images.accueil}}\" />\n    </div>\n\n    <div class=\"section center\">\n      <my-button my-label=\"$root.labels.begin\"\n        my-icon=\"$root.icons.begin\"\n        my-click=\"begin()\">\n      </my-button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/templates/home.html
// module id = 1462
// module chunks = 0